import { styled } from 'stitches.config'

export const EssentialsRoot = styled('div', {
    backgroundColor: '$tertiary-200',
  width: '100%',
  position: 'relative',
  '@bp2': {},

  '& strong': {
    fontWeight: '$semiBold'
  }
})

export const Spacer = styled('div', {
  height: '40px',
  background: '$tertiary-200',
})